<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :selectShow="false"
      :show="false"
      :submitData="submitData"
      @success="onSuccess"
      :goback="true"
    >
    </common-top-form>

    <common-table
      :data="tableData"
      ref="commonTable"
      :isShow="false"
      @handleChange="getPage"
      :width='100'
    >
      <el-table-column
        prop="merCode"
        min-width="150"
        label="商户号"
      ></el-table-column>
         <el-table-column
        prop='acqName'
        min-width="120"
        label="当前通道"
        :formatter="formatterTableData"
      >
     
      </el-table-column>
    <el-table-column
        prop="merType"
        label="商户类型"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.merType == 1">小微户</span>
          <span v-else-if="scope.row.merType == 2">个体户</span>
          <span v-else-if="scope.row.merType == 3">企业户</span>
        </template>
      </el-table-column>
        <el-table-column
        prop="merName"
        label="商户名称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
        <el-table-column
        prop="provinceCityCountyName"
        label="地区"
        min-width="250"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
        <el-table-column
        prop="addr"
        label="地址"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="mccName"
        label="商户种类"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
     <el-table-column
        prop="status"
        label="商户状态"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">正常</span>
          <span v-else-if="scope.row.status == 1">未开通（审核中）</span>
          <span v-else-if="scope.row.status == 2">失败</span>
        </template>
      </el-table-column>
          <el-table-column
        prop="busiLicenceNbr"
        label="执照编码"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
        <el-table-column
        prop="busiStime"
        label="开始日期"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
        
      >
        <template slot-scope="scope">
          <span v-if="scope.row.merType == 1">--</span>
          <span v-else-if="scope.row.merType != 1">{{scope.row.busiStime}}</span>
      
        </template>
      </el-table-column>
         <el-table-column
        prop="busiEtime"
        label="结束日期"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
       <template slot-scope="scope">
          <span v-if="scope.row.merType == 1">--</span>
          <span v-else-if="scope.row.merType != 1">{{scope.row.busiEtime}}</span>
      
        </template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FinanceService from "service/FinanceService";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "twoapppointsnewodetoJoyinfolook",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      isPage: false,
      page: {},
      formModel: {},
      impiementall: {},
      submitService: FinanceService.childList,
      tableData: [],
      status: [
        {
          dictKey: "0",
          dictValue: "未启动",
        },
        {
          dictKey: "1",
          dictValue: "进行中",
        },
        {
          dictKey: "2",
          dictValue: "已结束",
        },
        {
          dictKey: "3",
          dictValue: "已完成",
        },
      ],
   
    };
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      const params = {
        merCode: JSON.parse(this.$route.params.item).merCode,
        
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  created() {
    console.log(
      JSON.parse(this.$route.params.item).merCode,
      "this.$route.params.itemthis.$route.params.item"
    );
    this.impiementall = JSON.parse(this.$route.params.item);
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  watch: {},
  methods: {
    
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      console.log( this.submitService,this.submitData,'ddd')
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.onSuccess(res);
          this.isPage = false;
        },
        "信息获取失败"
      );
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/POSPmanage/channelBaseMessage.vue